import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackMetric } from './telemetry/telemetryService';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Send Web Vitals metrics (CLS, FID, FCP, LCP, TTFB) to Application Insights
reportWebVitals((metric) => {
  trackMetric(metric.name, metric.value, {
    webVitalId: metric.id,
    webVitalRating: (metric as unknown as Record<string, string>).rating || '',
  });
});
